import React, { useState } from 'react';
import { Form, Formik, Field } from 'formik';
import {
  Button as MuiButton,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import * as Yup from 'yup';
import styled from 'styled-components';
import CustomInput from './fields/Input';

const Heading = styled(Typography)`
  color: orange;
  & span {
    color: white;
    font-size: 2rem;
  }
  & small {
    color: white;
    font-size: 0.75rem;
  }
`;

const Button = styled(MuiButton)`
  background: white;
  color: ${props => props.theme.palette.primary.main};
  &:hover {
    background: lightgrey;
  }
`;

const ContactSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('We need an email address'),
});
const NewsLetterForm = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={ContactSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        fetch('https://api.formium.io/submit/5ebd90f228d5cb0001371a96/newsletter', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(values),
        });
        setOpen(true);
        resetForm({});
        setSubmitting(false);
      }}
    >
      {({ isSubmitting }) => (
        <Grid item container component={Form} spacing={1}>
          <Grid item xs component={Heading} variant="h3">
            <span>#</span>613pets
            <small> Ottawa's Newsletter for Pet Lovers</small>
          </Grid>
          <Grid xs={12} item>
            <Field name="email" label="Email Address" as={CustomInput} />
          </Grid>
          <Grid xs={12} item>
            <Button
              fullWidth
              disabled={isSubmitting}
              type="submit"
              variant="contained"
              endIcon={<SendIcon />}
            >
              Sign-up
            </Button>
          </Grid>
          <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="simple-dialog-title">
              Newsletter Sign-up
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You're almost on the list! A link to signup has been sent to
                your email.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MuiButton onClick={handleClose} color="secondary" autoFocus>
                Close
              </MuiButton>
            </DialogActions>
          </Dialog>
        </Grid>
      )}
    </Formik>
  );
};

export default NewsLetterForm;
